<div class="flex flex-nowrap justify-center items-center text-2xl m-auto mt-10 w-11/12 h-full p-4">
  <span class="h-10"> {{'codes.w-przygotowaniu' | translate}} </span>
  <span class="w-12 h-12" mmIkonaSvg="construction" class="ml-5"></span>
</div>
